<template>
    <div class="enterSecretQuestion-screen">
        <div class="leftContent">
            <custom-header :img-number="1"></custom-header>
        </div>
        <div class="rightContent" >
            <div class="headBlock">
                <custom-header />
            </div>
            <div class="wrap enterSecretQuestion_content">
                <div class="grow"></div>
                <h2  v-text="$ml.get('enterLoginPinCodeTitle')">Введіть ваш PIN-код</h2>

                <enter-pin-code
                    ref="pincode"
                    v-model="inputValue"
                    :errorMessage="isNotValidMessage"
                    :disabled="isLoading"
                    @keydown.native.enter="nextScreen"
                    @next="nextScreen"
                />
                <div class="grow"></div>
                <div class="bottom">
                    <div class="left">
                        <custom-button
                                :button-text="backButtonText"
                                back
                                :disabled="isLoading"
                                :action="back"
                        ></custom-button>
                    </div>
                    <div class="right">
                        <custom-button
                                :button-text="$ml.get('next')"
                                success
                                :disabled="disabledButton"
                                :action="nextScreen"
                        ></custom-button>
                    </div>
                </div>

                <a
                        class="link"
                        :class="{'disabledButton': isLoading}"
                        v-text="bottomText"
                        href="/login/enterSecretQuestion"
                        @click.prevent="enterBySecret"
                >Увійти з секретним запитанням</a>
                <!--<a-->
                        <!--class="link"-->
                        <!--:class="{'disabledButton': isLoading}"-->
                        <!--v-text="$ml.get('restoreAccountAccess')"-->
                        <!--@click.prevent="goToRecovery"-->
                        <!--href="/accessRecovery/"-->
                <!--&gt;Відновити доступ до акаунту</a>-->
            </div>
        </div>
    </div>
</template>

<script>
    import CustomHeader from "../../components/ui/custom-header";
    import LoginInput from "../../components/ui/login-input";
    import CustomButton from "../../components/ui/custom-button";
    import Profile from '../../helpers/profile';
    import {verifySecretCode as apiVerifySecretCode, getApiErrorMessage} from '../../helpers/api';
    import EnterPinCode from "../../components/layout/enterPinCode.vue";

    export default {
        name: "enterPinCodePage",
        components: {
            EnterPinCode,
            CustomButton, LoginInput, CustomHeader},
        data() {
            return {
                inputValue: '',
                isLoading: false,
                isNotValidMessage: '',
            }
        },

        computed: {
            disabledButton: function() {
                return this.inputValue.length !== 4 || this.isLoading;
            },

            bottomText: function () {
//                return Profile.process === 'accessRecovery' ? this.$ml.get('registration') : this.$ml.get('restoreAccountAccess')
                return this.$ml.get('enterLoginPinCodeBottomLink')
            },
            backButtonText: function () {
                return Profile.otptype === 'sms' ? this.$ml.get('sendCodeChangePhone') :
                    this.$ml.get('sendCodeChangeMail');
            }
        },

        mounted () {
            Profile.setData({ pincode: '' });
            this.$refs.pincode.focus();
        },

        methods: {
            nextScreen: function () {
                if (this.inputValue.length !== 4) {
                    this.$refs.pincode.showError(this.$ml.get('enterLoginPinCodeTitle'));
                    return;
                }
                if (this.isLoading || Profile.redirectTo)
                    return;
                this.isLoading = true;
                this.$loader.show();
                this.isNotValidMessage = '';
                if (Profile.process === 'accessRecovery') {
                    this.$router.push({ name: 'AccessRecoveryInfoSelectLogin'});
                } else {
                    apiVerifySecretCode(this.inputValue, 'pincode').then(()=>{

                    }, err => {
                        if (err.status == 428) {
                            this.$router.push('/login/infoSetAdditionalParams');
                            return;
                        }
                        this.isNotValidMessage = getApiErrorMessage(err, {
                            '401': this.$ml.get('secretQuestionErrorAnswer'),
                            '409': this.$ml.get('errorPinCodeNotAllowed')
                        });
                        Profile.setData({
                            sanswer: '',
                            pincode: '',
                        });
                    }).finally(()=>{
                        if (!Profile.redirectTo) {
                            this.isLoading = false;
                            this.$loader.hide();
                        }
                    });
                }
            },

            back: function () {
                this.$router.push({name: 'LoginEnterLogin'});
            },

            enterBySecret: function () {
                if (this.isLoading)
                    return;
                this.$router.push('/login/enterSecretQuestion');
            },

            goToRecovery: function () {
                if (this.isLoading)
                    return;
                this.$router.push({name: 'AccessRecoveryStart'});
            },

        }

    }
</script>
<style lang="scss">
    .enterSecretQuestion_content {
        .trailingIcon {
            cursor: default !important;
        }
    }
</style>
<style lang="scss" scoped>

        .enterSecretQuestion_content {
            display: flex;
            flex-direction: column;
            min-height: calc(100vh - 150px);
            justify-content: space-between;
        }
        .question {
            text-align: left;
            font-weight: 500;
            margin-bottom: 0;
        }
        .prompt {
            text-align: left;
            font-weight: 300;
            font-size: 12px;
            line-height: 16px;
            color: #7B7B7B;
        }
        .link {
            color: #5CD69B;
            font-weight: 300;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            margin: 12px 0;
            &.disabledButton {
                color: #c3c3c3;
                &:hover, &:focus {
                    color: #c3c3c3;
                    cursor: default;
                    text-decoration: none;
                }
            }
        }

    @media (min-width: 601px) and (max-width: 750px) {
        .question, .prompt {
            font-size: 18px;
            line-height: 24px;
        }
        .link {
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
        }
        .enterSecretQuestion_content {
            height: calc(100vh - 160px);
            max-height: 700px;
        }
    }
    @media (min-width: 751px) {
        .question, .prompt {
            font-size: 18px;
            line-height: 24px;
        }
        .prompt {
            margin-top: 6px;
        }
        .link {
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
        }
        .enterSecretQuestion_content  {
            height: calc(100vh - 160px);
            max-height: 700px;
        }
    }

</style>